// AppRoutes.tsx
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginLayout from "../layouts/LoginLayout";
import MainLayout from "../layouts/MainLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Thing from "../pages/Thing/Thing";
import Project from "../pages/Project/Project";
import Application from "../pages/Application/Application";
import EventLog from "../pages/EventLog/EventLog";
import Member from "../pages/Member/Member";
import Profile from "../pages/Login/Profile";
import {
  ROUTE_APPLICATION,
  ROUTE_APPLICATION_CREATE,
  ROUTE_APPLICATION_EDIT,
  ROUTE_APPLICATION_INFORMATION,
  ROUTE_DASHBOARD,
  ROUTE_EVENTLOG,
  ROUTE_LOGIN,
  ROUTE_MEMBER,
  ROUTE_PROFILE,
  ROUTE_PROJECT,
  ROUTE_PROJECT_INFORMATION,
  ROUTE_THING,
  ROUTE_THING_CREATEEDIT,
  ROUTE_THING_EDITBUCKETS,
  ROUTE_THING_INFOMAIN,
} from "../constants";
import ThingCreateEdit from "../pages/Thing/ThingCreateEdit";
import ThingInfoMain from "../pages/Thing/ThingInfoMain";
import ThingEditBuckets from "../pages/Thing/ThingEditBuckets";
import ProjectInformation from "../pages/Project/ProjectInformation";
import ApplicationInformation from "../pages/Application/ApplicationInformation";
import ApplicationCreateEdit from "../pages/Application/ApplicationCreateEdit";
import { isLogin } from "../utils/functions";
import NotFound from "../pages/NotFound/NotFound";

const AppRoutes: React.FC = () => {
  const [authenticated, setAuthenticated] = useState(isLogin());

  useEffect(() => {
    const checkLoginStatus = () => {
      setAuthenticated(isLogin());
    };

    window.addEventListener("storage", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", checkLoginStatus);
    };
  }, []);

  return (
    <Routes>
      <Route path={ROUTE_LOGIN} element={<LoginLayout />} />
      <Route path="/" element={<Navigate to={ROUTE_DASHBOARD} replace />} />
      <Route
        path="/"
        element={authenticated ? <MainLayout /> : <Navigate to={ROUTE_LOGIN} />}
      >
        <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
        <Route path={ROUTE_THING} element={<Thing />} />
        <Route path={ROUTE_THING_CREATEEDIT} element={<ThingCreateEdit />} />
        <Route path={ROUTE_THING_INFOMAIN} element={<ThingInfoMain />} />
        <Route path={ROUTE_THING_EDITBUCKETS} element={<ThingEditBuckets />} />
        <Route path={ROUTE_PROJECT} element={<Project />} />
        <Route
          path={ROUTE_PROJECT_INFORMATION}
          element={<ProjectInformation />}
        />
        <Route path={ROUTE_APPLICATION} element={<Application />} />
        <Route
          path={ROUTE_APPLICATION_INFORMATION}
          element={<ApplicationInformation />}
        />
        <Route
          path={ROUTE_APPLICATION_CREATE}
          element={<ApplicationCreateEdit />}
        />
        <Route
          path={ROUTE_APPLICATION_EDIT}
          element={<ApplicationCreateEdit />}
        />
        <Route path={ROUTE_EVENTLOG} element={<EventLog />} />
        <Route path={ROUTE_MEMBER} element={<Member />} />
        <Route path={ROUTE_PROFILE} element={<Profile />} />
        <Route path="*" element={<NotFound />} />
      </Route>

    </Routes>
  );
};

export default AppRoutes;
